import { combineReducers } from 'redux';

import dao from './ducks/dao';

export default combineReducers({
  dao: dao.reducer,
});
